// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactRequests_btnClass__kugqc {
  height: 50px;
  padding-inline: 50px;
}

.ContactRequests_overlay__n6U85 {
  background-color: #fff;
  box-shadow: 0px 3px 10px 0px rgba(149, 152, 174, 0.4);
  border-radius: 5px;
  border: 1px solid #fff;
  padding: 0;
  width: fit-content;
  z-index: 2 !important;
  position: relative;
}
.ContactRequests_inventoryActionIcon__f7HRE {
  background-color: var(--primary-text-color);
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
}
.ContactRequests_overlay__n6U85 .ContactRequests_overlayLink__YPWWq {
  font-size: 14px !important;
  color: #333 !important;
  text-decoration: none;
  text-transform: capitalize;

  cursor: pointer;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactRequests/ContactRequests.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;;EAE1B,eAAe;EACf,aAAa;AACf","sourcesContent":[".btnClass {\n  height: 50px;\n  padding-inline: 50px;\n}\n\n.overlay {\n  background-color: #fff;\n  box-shadow: 0px 3px 10px 0px rgba(149, 152, 174, 0.4);\n  border-radius: 5px;\n  border: 1px solid #fff;\n  padding: 0;\n  width: fit-content;\n  z-index: 2 !important;\n  position: relative;\n}\n.inventoryActionIcon {\n  background-color: var(--primary-text-color);\n  width: 22px;\n  height: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n}\n.overlay .overlayLink {\n  font-size: 14px !important;\n  color: #333 !important;\n  text-decoration: none;\n  text-transform: capitalize;\n\n  cursor: pointer;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnClass": `ContactRequests_btnClass__kugqc`,
	"overlay": `ContactRequests_overlay__n6U85`,
	"inventoryActionIcon": `ContactRequests_inventoryActionIcon__f7HRE`,
	"overlayLink": `ContactRequests_overlayLink__YPWWq`
};
export default ___CSS_LOADER_EXPORT___;
